"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _hostCommonQuestionsIntl = require("../host-common-questions-intl");
var _consultationBtnIntl = require("../consultation-btn-intl");
var _createListingBtnIntl = require("../create-listing-btn-intl");
var _SpaceTypeFormIntl = require("../../elements-forms/SpaceTypeForm-intl");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var spaceWidgetId = document.getElementById('space-widget');
if (spaceWidgetId) {
  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_SpaceTypeFormIntl.SpaceTypeFormIntl, null), spaceWidgetId);
}
var commonQuestions = document.getElementById('common-questions');
if (commonQuestions) {
  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_hostCommonQuestionsIntl.HostCommonQuestionsIntl, null), commonQuestions);
}
var createListingBtn = document.getElementById('create-listing-btn');
if (createListingBtn) {
  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_createListingBtnIntl.CreateListingBtnIntl, null), createListingBtn);
}
var consultationBtn = document.getElementById('consultation-btn');
if (consultationBtn) {
  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_consultationBtnIntl.ConsultationBtnIntl, null), consultationBtn);
}